import { c as _c } from "react/compiler-runtime";
import { startTransition, useMemo } from "react";
import { useThemeStore } from "@/store/theme-store";
import { getColorGenerator } from "@/lib/color-generator";
export const useColorUpdate = props => {
  const $ = _c(13);
  const sync = useThemeStore(_temp);
  const platform = useThemeStore(_temp2);
  const _theme = useThemeStore(_temp3);
  const theme = props?.updateTheme ?? _theme;
  const setPrimaryColor = useThemeStore(_temp4);
  const setSecondaryColor = useThemeStore(_temp5);
  const setAccentColor = useThemeStore(_temp6);
  const setMutedColor = useThemeStore(_temp7);
  let t0;
  let t1;
  if ($[0] !== platform || $[1] !== sync || $[2] !== theme) {
    t1 = getColorGenerator(platform, theme, sync);
    $[0] = platform;
    $[1] = sync;
    $[2] = theme;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  t0 = t1;
  const generator = t0;
  let t2;
  if ($[4] !== generator || $[5] !== setAccentColor || $[6] !== setMutedColor || $[7] !== setPrimaryColor || $[8] !== setSecondaryColor) {
    t2 = (colorKey, newColor) => {
      startTransition(() => {
        bb27: switch (colorKey) {
          case "primary":
            {
              const newColors = generator.generateFromPrimary(newColor);
              setPrimaryColor(newColors);
              break bb27;
            }
          case "secondary":
            {
              const newSecondaryColors = generator.generateFromSecondary(newColor);
              setSecondaryColor(newSecondaryColors);
              break bb27;
            }
          case "accent":
            {
              const newAccentColors = generator.generateFromAccent(newColor);
              setAccentColor(newAccentColors);
              break bb27;
            }
          case "muted":
            {
              const newMutedColors = generator.generateFromMuted(newColor);
              setMutedColor(newMutedColors);
              break bb27;
            }
          default:
            {}
        }
      });
    };
    $[4] = generator;
    $[5] = setAccentColor;
    $[6] = setMutedColor;
    $[7] = setPrimaryColor;
    $[8] = setSecondaryColor;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const updateColor = t2;
  const t3 = useThemeStore(_temp8);
  let t4;
  if ($[10] !== t3 || $[11] !== updateColor) {
    t4 = {
      updateColor,
      colorPalette: t3
    };
    $[10] = t3;
    $[11] = updateColor;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
function _temp(state) {
  return state.sync[state.platform];
}
function _temp2(state_0) {
  return state_0.platform;
}
function _temp3(state_1) {
  return state_1.theme;
}
function _temp4(state_2) {
  return state_2.setPrimaryColor;
}
function _temp5(state_3) {
  return state_3.setSecondaryColor;
}
function _temp6(state_4) {
  return state_4.setAccentColor;
}
function _temp7(state_5) {
  return state_5.setMutedColor;
}
function _temp8(state_6) {
  return state_6.colors[state_6.platform][state_6.theme];
}